export default "__VITE_ASSET__6c23e6dd__"